const cache = new Map<string, Map<string, Promise<string>>>();

/** Returns a named in-memory cache map, creating it lazily if it does not exist */
export function useCache(name: string): Map<string, Promise<string>> {
  if (!cache.has(name)) {
    cache.set(name, new Map<string, Promise<string>>());
  }
  return cache.get(name)!;
}
